export const GET_ACTIVITIES_BEGIN = 'GET_ACTIVITIES_BEGIN';
export const GET_ACTIVITIES_SUCCESS = 'GET_ACTIVITIES_SUCCESS';
export const GET_ACTIVITIES_ERROR = 'GET_ACTIVITIES_ERROR';

export const DISPLAY_ALERT = 'SHOW_ALERT';
export const CLEAR_ALERT = 'CLEAR_ALERT';

export const SETUP_USER_BEGIN = 'SETUP_USER_BEGIN';
export const SETUP_USER_SUCCESS = 'SETUP_USER_SUCCESS';
export const SETUP_USER_ERROR = 'SETUP_USER_ERROR';

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const LOGOUT_USER = 'LOGOUT_USER';

export const UPDATE_USER_BEGIN = 'UPDATE_USER_BEGIN';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';

export const HANDLE_CHANGE = 'HANDLE_CHANGE';
export const CLEAR_VALUES = 'CLEAR_VALUES';

export const CREATE_LESSON_BEGIN = 'CREATE_LESSON_BEGIN';
export const CREATE_LESSON_SUCCESS = 'CREATE_LESSON_SUCCESS';
export const CREATE_LESSON_ERROR = 'CREATE_LESSON_ERROR';

export const GET_LESSONS_BEGIN = 'GET_LESSONS_BEGIN';
export const GET_LESSONS_SUCCESS = 'GET_LESSONS_SUCCESS';
export const GET_LESSONS_ERROR = 'GET_LESSONS_ERROR';

export const SET_EDIT_LESSON = 'SET_EDIT_LESSON';

export const DELETE_LESSON_BEGIN = 'DELETE_LESSON_BEGIN';
export const DELETE_LESSON_ERROR = 'DELETE_LESSON_ERROR';

export const EDIT_LESSON_BEGIN = 'EDIT_LESSON_BEGIN';
export const EDIT_LESSON_SUCCESS = 'EDIT_LESSON_SUCCESS';
export const EDIT_LESSON_ERROR = 'EDIT_LESSON_ERROR';

export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const CHANGE_PAGE = 'CHANGE_PAGE';

export const GET_CURRENT_USER_BEGIN = 'GET_CURRENT_USER_BEGIN';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
